import React from 'react';
import { useSharedTimer } from '../hooks/useSharedTimer';
interface CountdownTimerProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}
export function CountdownTimer({
  className = '',
  size = 'md'
}: CountdownTimerProps) {
  const {
    formattedTime
  } = useSharedTimer();
  const sizeClasses = {
    sm: 'text-lg font-bold',
    md: 'text-3xl md:text-4xl font-black tracking-wider',
    lg: 'text-5xl md:text-7xl font-black tracking-widest'
  };
  return <div className={`font-mono text-[#C67B30] drop-shadow-[0_0_8px_rgba(198,123,48,0.3)] ${sizeClasses[size]} ${className}`} data-id="element-31">
      {formattedTime}
    </div>;
}